import axios from 'axios';
import { isEmptyString, getCookie, setCookie } from '../utils';
import { FETCH_LOCATION,GET_EARNING_POTENTIAL,SIGN_OUT,TRANSLATION_AND_IMAGES } from '../utils/endpoints';

const skipAuthPaths = {
    GET: [
        FETCH_LOCATION,
        GET_EARNING_POTENTIAL,
        TRANSLATION_AND_IMAGES
    ],
    POST: [],
};

const nodeEndpoints = {
    GET:[
        FETCH_LOCATION,
        GET_EARNING_POTENTIAL,
        TRANSLATION_AND_IMAGES
    ],
    POST:[]
};

const basePrefix = '/api/discovery/api/';

const GET = (endpoint, params, overrideHeaders, onSuccess, onError) => {
    
    const accessToken = getCookie('user_access_token');
    if (!skipAuthPaths.GET.includes(endpoint) && isEmptyString(accessToken)) { forceLogout(); return; }
    
    const headers = {
        'access_token': accessToken,
        'Content-Type': 'application/json',
        'timezone_offset': new Date().getTimezoneOffset(),
        ...overrideHeaders
    };
    params = params == null ? {} : params;
    
    params['_hash'] = new Date().getTime();
    
    let requestEndpoint = basePrefix+endpoint;
    
    if(nodeEndpoints.GET.includes(endpoint)){
        requestEndpoint = endpoint
    }
    
    axios.get(requestEndpoint, { headers, params, timeout: 60000 })
        .then(response => typeof onSuccess === "function" && onSuccess(response.data || response))
        .catch(error => {
            if (error.response && error.response.status === 401) {
                forceLogout();
                return;
            }
            typeof onError === "function" && onError(error.response != null ? error.response.data : error,error.response && error.response.status);
        });

};

const POST = (endpoint, params, data, overrideHeaders, onSuccess, onError) => {
    
    const accessToken = getCookie('user_access_token');
    if (!skipAuthPaths.POST.includes(endpoint) && isEmptyString(accessToken)) { forceLogout(); return; }

    const headers = {
        'access_token': accessToken,
        'Content-Type': 'application/json',
        'timezone_offset': new Date().getTimezoneOffset(),
        ...overrideHeaders,
    };

    if (overrideHeaders && overrideHeaders.formData) delete headers['Content-Type'];
    params = params == null ? {} : params;
    
    params['_hash'] = new Date().getTime();
    
    axios.post(basePrefix+endpoint, data, { headers, params, timeout: 60000 })
        .then((response) => typeof onSuccess === "function" && onSuccess(response.data))
        .catch(error => {
            if (error.response && error.response.status === 401) {
                forceLogout();
                return;
            }
            typeof onError === "function" && onError(error.response != null ? error.response.data : error,error.response && error.response.status);
        });

};

export const forceLogout = error => {
    if (!isEmptyString(getCookie('user_access_token'))) signOut();
    setCookie('user_access_token', '', -1);
    setCookie('login', true, 1);
    window.location = '/';
    // TODO: need to remove data in redux
    // error != null && Storage.setItem(STORE_KEYS.LOGIN_ERROR, error);
    // redirect to landing page
};

const signOut = () => {
    POST(SIGN_OUT, null, null, null,
        response => console.info('success sign_out: ', response),
        error => console.error('error sign_out: ', error));
};

export default {
    GET,
    POST
};
